import { Routes } from '@angular/router';
import { NotAuthGuard, AuthGuard } from './core/guard/auth-guard.service';
/**
 * App routes
 * This file contains the routes for the application.
 * @returns An array of routes for the application.
 */
export const appRoutes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth-routes'),
        canActivate: [NotAuthGuard]
    },
    {
        path: 'pages',
        loadChildren: () => import('./pages/page-routes'),
        runGuardsAndResolvers: 'always',
        canMatch: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: 'pages',
        pathMatch: 'full'
    }
];